import React from 'react';
import img1 from '../images/g1.jpg'
import img2 from '../images/g2.jpg'
import img3 from '../images/g3.jpg'
import img4 from '../images/g4.jpg'
import img5 from '../images/g5.jpg'
import img6 from '../images/g6.jpg'
import img7 from '../images/g7.jpg'
import img8 from '../images/g8.jpg'
import img9 from '../images/g9.jpg'
import img10 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.37.55_ddc05d47.jpg'
import img11 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.37.56_ce9186b7.jpg'
import img12 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.37.57_afccaaf4.jpg'
import img13 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.37.58_b1619f49.jpg'
import img14 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.37.59_314c7bd6.jpg'
import img15 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.10_58f69213.jpg'
import img16 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.17_da486043.jpg'
import img17 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.18_abbffb8f.jpg'
import img18 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.24_912252b0.jpg'
import img19 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.26_f9cd7086.jpg'
import img20 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.28_d9a24f9e.jpg'
import img21 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.31_4fb1ebd3.jpg'
import img22 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.32_49d05b6e.jpg'
import img23 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.35_78674a44.jpg'
import img24 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.42_c5677beb.jpg'
import img25 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.39_92e4bb66.jpg'
import img26 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.42_65a3c76f.jpg'
import img27 from '../images/galleryImage/WhatsApp Image 2024-07-06 at 09.38.42_c5677beb.jpg'
import '../style/landingGallery.css'



const LandingSlider = () => {
  return (
    <>
      <div className='container'>
        <div class="marquee4 marquee--4">
          <img class="marquee__item4" src={img10} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img11} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img12} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img13} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img14} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img15} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img16} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img18} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img19} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img20} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img21} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img22} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img23} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img24} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img25} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img26} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img27} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img1} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img2} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img3} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img4} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img5} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img6} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img7} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img8} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img9} width={'400px'} height={'400px'} alt="alt_image" />
          <img class="marquee__item4" src={img17} width={'400px'} height={'400px'} alt="alt_image" />
        </div>
      </div>
    </>
  );
};

export default LandingSlider;